"use client";

import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import {
  CarouselContent,
  CarouselCounter,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselProvider,
  CarouselRoot,
} from "./parts";
import type { CarouselWrapperProps } from "./types";

function WrappedCarousel({
  id,
  children,
  className,
  options,
  plugins,
  orientation,
  neighborSlidesOffset = 1,
  setApi,
  ...props
}: CarouselWrapperProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <CarouselProvider
      options={options}
      plugins={plugins}
      orientation={orientation}
      neighborSlidesOffset={neighborSlidesOffset}
      setApi={setApi}
    >
      <CarouselRoot id={id} className={cn(className, classes)} {...native}>
        {children}
      </CarouselRoot>
    </CarouselProvider>
  );
}

const Carousel = Object.assign(WrappedCarousel, {
  Content: CarouselContent,
  Counter: CarouselCounter,
  Dots: CarouselDots,
  Item: CarouselItem,
  Next: CarouselNext,
  Prev: CarouselPrevious,
});

export default Carousel;
